import React from 'react';
import { AudioPlayer } from '@cp/ds/src/components/audioPlayer';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { AUDIO_EXAMPLE_SRC } from '../const';

export const Footer = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Stack sx={{ borderTop: `1px solid ${theme.palette['gray middle']}` }}>
      <Typography sx={{ color: { xs: theme.palette.gray, md: theme.palette['brand gray'] }, textAlign: 'center', py: 2.5 }}>
        Послушайте примеры. Вы можете быстро записать подобное обращение для своей анкеты.
      </Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 2.5 }}>
        <Stack alignItems="center">
          <Typography sx={{ mb: { xs: 1, md: 1.5 }, alignSelf: { xs: 'flex-start', md: 'center' } }}>Елена</Typography>
          <AudioPlayer size={isMobile ? 'normal' : 'small'} source={AUDIO_EXAMPLE_SRC} />
        </Stack>
        <Stack alignItems="center">
          <Typography sx={{ mb: { xs: 1, md: 1.5 }, alignSelf: { xs: 'flex-start', md: 'center' } }}>Татьяна</Typography>
          <AudioPlayer size={isMobile ? 'normal' : 'small'} source={AUDIO_EXAMPLE_SRC} />
        </Stack>
        <Stack alignItems="center">
          <Typography sx={{ mb: { xs: 1, md: 1.5 }, alignSelf: { xs: 'flex-start', md: 'center' } }}>Ульяна</Typography>
          <AudioPlayer size={isMobile ? 'normal' : 'small'} source={AUDIO_EXAMPLE_SRC} />
        </Stack>
      </Stack>
    </Stack>
  );
};
